
const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:4dc8ae1f-80e7-4dc6-99ee-1f2ac5413937",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_uHeFVJ9n4",
    "aws_user_pools_web_client_id": "1fcd9bphu3oeshhbbqdihpr9ra",
    "oauth": {}
};

export default awsmobile;
